import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wave-duration" }

import {
  onMounted,
  onUnmounted,
  ref,
  toRef,
  watch,
  nextTick,
} from "vue";
import WFPlayer from "wfplayer";
import { getTimeDurationText } from "@/common/tool";


export default /*#__PURE__*/_defineComponent({
  props: {
  url: String,
  duration: Number,
},
  setup(__props) {

const props = __props


const playing = ref(false);
const audio = ref<HTMLAudioElement>();
const waveBox = ref<HTMLDivElement>();
const url = toRef(props, "url");
let wf: WFPlayer;
const initPlayer = () => {
  wf && wf.destroy();
  if (waveBox.value && url.value && audio.value) {
    audio.value.src = url.value;
    wf = new WFPlayer({
      container: waveBox.value,
      mediaElement: audio.value,
      grid: false,
      ruler: false,
      scrollable: true,
      scrollbar: false,
      padding: 0,
      waveColor: "rgba(255, 255, 255, 0.5)",
      progressColor: "rgba(255, 255, 255, 1)",
      backgroundColor: "#FBC126",
    });
    setTimeout(() => {
      url.value && wf.load(url.value);
    }, 50);
  }
};

const playVoice = () => {
  if (audio.value) {
    if (audio.value.paused) {
      audio.value.play();
    } else {
      audio.value.pause();
    }
  }
};
const handlePlay = () => {
  playing.value = true;
};
const handlePause = () => {
  playing.value = false;
};
const handleEnded = () => {
  wf && wf.seek(0);
};
onMounted(initPlayer);
onUnmounted(() => wf && wf.destroy());
watch(url, () => {
  nextTick(initPlayer);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wave-player",
    onClick: playVoice
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["voice-icon", [playing.value ? 'icon-pause' : 'icon-play']])
    }, null, 2),
    _createElementVNode("div", {
      class: "wave-box",
      ref_key: "waveBox",
      ref: waveBox
    }, null, 512),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(getTimeDurationText)(__props.duration || 0)), 1),
    _createElementVNode("audio", {
      ref_key: "audio",
      ref: audio,
      onPlay: handlePlay,
      onPause: handlePause,
      onEnded: handleEnded
    }, null, 544)
  ]))
}
}

})